import { TRUSTED_BRANDS } from "../lib/constants";

export default function BrandMarquee() {
  const items = [...TRUSTED_BRANDS, ...TRUSTED_BRANDS];
  return (
    <section
      data-testid="brand-marquee"
      className="py-14 border-y border-slate-200 bg-slate-50 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 mb-6 flex items-center justify-between gap-4 flex-wrap">
        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700">
          <span className="h-px w-8 bg-teal-700" />
          Marques travaillées
        </div>
        <div className="text-xs text-slate-500 font-semibold uppercase tracking-widest">
          Certifié A2P · Hautes sécurités
        </div>
      </div>
      <div className="relative">
        <div className="flex animate-marquee w-max">
          {items.map((b, i) => (
            <div
              key={i}
              className="mx-12 font-display text-3xl md:text-5xl font-black text-slate-300 uppercase tracking-widest whitespace-nowrap select-none"
            >
              {b}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50 to-transparent" />
      </div>
    </section>
  );
}
